import { User, YammerState } from '../../state/types';

type GetSelectedOnBehalfOfUserId = (state: YammerState) => User['id'] | undefined;
export const getSelectedOnBehalfOfUserId: GetSelectedOnBehalfOfUserId = (state) =>
  state.analyticsSettings.selectedOnBehalfOfUserId;
